import { createClient } from '@supabase/supabase-js'

const supabaseUrl =
  'https://skxfxtyvzccitrakjkyx.supabase.co'

const supabasePublishableKey =
  'sb_publishable_x78bYuzAlgEenQzaI0KG6w_sMvBlZ6T'

if (!supabaseUrl.includes('.supabase.co')) {
  throw new Error('La URL de Supabase no es válida')
}

if (!supabasePublishableKey.startsWith('sb_publishable_')) {
  throw new Error(
    `Clave incorrecta: ${supabasePublishableKey.slice(0, 14)}`
  )
}

console.log(
  'Supabase iniciado con:',
  supabasePublishableKey.slice(0, 15)
)

export const supabase = createClient(
  supabaseUrl,
  supabasePublishableKey
)